import { DeviceIssueType } from '@/types/devices';
import { IconNames } from '@electricjs/arc';
import {
  ActionType,
  AssetActionEnum,
  AssetEventCategory,
  CalculatedEventTypes,
  DirectoryInsightEventType,
} from '@electricjs/core_entity-client';

export const EventTypeMap: Record<ActionType, string> = {
  [DirectoryInsightEventType.AdminLoginAttempt]: 'Admin login attempt',
  [AssetActionEnum.Assign]: 'Assign',
  [AssetActionEnum.ChangeSite]: 'Change site',
  [AssetActionEnum.ChangeStatus]: 'Change status',
  [DirectoryInsightEventType.CommandRun]: 'Command run',
  [AssetActionEnum.DeleteImage]: 'Delete image',
  [CalculatedEventTypes.DeviceHealthIssue]: 'Device health issue',
  [AssetActionEnum.DeviceIssueCreated]: 'Device issue created',
  [AssetActionEnum.DeviceIssueIgnored]: 'Device issue ignored',
  [AssetActionEnum.DeviceIssueReminder]: 'Device issue reminder',
  [AssetActionEnum.DeviceIssueResolved]: 'Device issue resolved',
  [CalculatedEventTypes.DeviceLock]: 'Device lock',
  [AssetActionEnum.DeviceLockError]: 'Device lock error',
  [AssetActionEnum.DeviceLockTimeout]: 'Device lock timeout',
  [AssetActionEnum.DeviceRemovedFromMdm]: 'Device removed from MDM',
  [AssetActionEnum.ChangeMdmStatusOverride]: 'Change MDM status override',
  [AssetActionEnum.DeviceUnenrollDone]: 'Device unenroll done',
  [AssetActionEnum.DeviceUnenrollRequested]: 'Device unenroll requested',
  [AssetActionEnum.DeviceUnenrollError]: 'Device unenroll error',
  [AssetActionEnum.DeviceWipeDone]: 'Device wipe done',
  [AssetActionEnum.DeviceWipeError]: 'Device wipe error',
  [AssetActionEnum.DeviceWipeRequested]: 'Device wipe requested',
  [AssetActionEnum.DeviceWipeTimeout]: 'Device wipe timeout',
  [CalculatedEventTypes.Firewall]: 'Firewall',
  [DirectoryInsightEventType.LoginAttempt]: 'Login attempt',
  [DirectoryInsightEventType.MdmCommandResult]: 'MDM command result',
  [DirectoryInsightEventType.OsMinorUpgrade]: 'OS minor upgrade',
  [DirectoryInsightEventType.PolicyResult]: 'Policy result',
  [DirectoryInsightEventType.SoftwareAdd]: 'Software add',
  [DirectoryInsightEventType.SoftwareChange]: 'Software change',
  [AssetActionEnum.Unassign]: 'Unassign',
  [AssetActionEnum.UploadImage]: 'Upload image',
  [AssetActionEnum.FileUploadRejected]: 'File upload rejected',
};

export const CategoryMap: Record<AssetEventCategory, string> = {
  [AssetEventCategory.Asset]: 'Asset',
  [AssetEventCategory.Hardware]: 'Hardware',
  [AssetEventCategory.Security]: 'Security',
};

export const EventTypeIconMap: { [key in ActionType]?: IconNames } = {
  [AssetActionEnum.Assign]: 'user-check',
  [AssetActionEnum.Unassign]: 'user-minus',
  [AssetActionEnum.ChangeSite]: 'pin',
  [AssetActionEnum.DeviceLockTimeout]: 'lock',
  [AssetActionEnum.DeviceLockError]: 'lock',
  [AssetActionEnum.DeviceWipeRequested]: 'broom',
  [AssetActionEnum.DeviceWipeDone]: 'broom',
  [AssetActionEnum.DeviceWipeTimeout]: 'broom',
  [AssetActionEnum.DeviceWipeError]: 'broom',
  [AssetActionEnum.DeviceUnenrollRequested]: 'plug-circle-xmark',
  [AssetActionEnum.DeviceUnenrollDone]: 'plug-circle-xmark',
  [AssetActionEnum.DeviceUnenrollError]: 'plug-circle-xmark',
  [AssetActionEnum.DeviceRemovedFromMdm]: 'laptop-arrow-down-sharp',
  [AssetActionEnum.UploadImage]: 'file',

  // Directory Insight Events
  [DirectoryInsightEventType.LoginAttempt]: 'logout',
  [DirectoryInsightEventType.AdminLoginAttempt]: 'logout',
  [DirectoryInsightEventType.SoftwareAdd]: 'app',
  [DirectoryInsightEventType.SoftwareChange]: 'cog',
  [DirectoryInsightEventType.PolicyResult]: 'shield-check',
  [DirectoryInsightEventType.OsMinorUpgrade]: 'cog',
  [DirectoryInsightEventType.MdmCommandResult]: 'cog',
  [DirectoryInsightEventType.CommandRun]: 'cog',

  [CalculatedEventTypes.DeviceLock]: 'lock',
  [CalculatedEventTypes.Firewall]: 'firewall',
};

export const DeviceHealthIssueIconMap: Record<DeviceIssueType, IconNames> = {
  [DeviceIssueType.Encryption]: 'key',
  [DeviceIssueType.Firewall]: 'firewall',
  [DeviceIssueType.Gatekeeper]: 'shield-virus',
  [DeviceIssueType.OS]: 'cog',
  [DeviceIssueType.Storage]: 'storage',
  [DeviceIssueType.RAM]: 'ram',
  [DeviceIssueType.OsqueryNotReporting]: 'plug-circle-xmark',
  [DeviceIssueType.MdmNotReporting]: 'plug-circle-xmark',
  [DeviceIssueType.DeviceLock]: 'laptop-arrow-down-sharp',
} as const;
